import React from "react";
import Mydata from "../../data/blog/sportEvent.json";
function content() {
  const Data = Mydata[1];
  return (
    <div className="mx-auto max-w-5xl px-4 text-[#2B3252]">
      {Data.heading.map((item, index) => {
        return (
          <>
            {item.title && (
              <h2 className="blogtitle">{item.title}</h2>
            )}
{item.content && (
  <p
    className="blogcontent"
    dangerouslySetInnerHTML={{ __html: item.content }}
  ></p>
)}
{item.content2 && (
  <p
    className="blogcontent"
    dangerouslySetInnerHTML={{ __html: item.content2 }}
  ></p>
)}
{item.content3 && (
  <p
    className="blogcontent"
    dangerouslySetInnerHTML={{ __html: item.content3 }}
  ></p>
)}

          </>
        );
      })}
    </div>
  );
}

export default content;
